import { render } from "./Gridblock.vue?vue&type=template&id=a03628a4&scoped=true"
import script from "./Gridblock.vue?vue&type=script&lang=js"
export * from "./Gridblock.vue?vue&type=script&lang=js"

import "./Gridblock.vue?vue&type=style&index=0&id=a03628a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a03628a4"]])

export default __exports__